import {
    CustomButtonColor
} from '../../../../UiComponentsLibrary/CustomButton/constants/CustomButtonColor';
import { BookingStep } from '../constants/DetailedBookingConstants';

export interface ButtonConfig {
  id: string;
  text: string;
  backgroundColor: string;
  handleOnClickCb?: () => void;
  disabled?: boolean;
}

export interface GtmReviewButtonConfig {
  visible: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const createButtonConfig = (
  onClose: () => void,
  handleNextClick: () => void,
  handlePreviousClick: () => void,
  handleSubmitClick: () => void,
  isNextEnabled: boolean,
  gtmReviewButton?: GtmReviewButtonConfig
): Record<BookingStep, ButtonConfig[]> => ({
  [BookingStep.INITIAL]: [
    {
      id: 'cancel-button',
      text: 'cancel-button',
      backgroundColor: CustomButtonColor.cancel,
      handleOnClickCb: onClose,
    },
    {
      id: 'next-button',
      text: 'next-button',
      backgroundColor: isNextEnabled
        ? CustomButtonColor.next
        : CustomButtonColor.disabled,
      handleOnClickCb: handleNextClick,
      disabled: !isNextEnabled,
    },
  ],
  [BookingStep.DETAILED]: [
    {
      id: 'cancel-button',
      text: 'cancel-button',
      backgroundColor: CustomButtonColor.cancel,
      handleOnClickCb: onClose,
    },
    {
      id: 'previous-button',
      text: 'previous-button',
      backgroundColor: CustomButtonColor.previous,
      handleOnClickCb: handlePreviousClick,
    },
    ...(gtmReviewButton?.visible
      ? [
          {
            id: 'send-for-gtm-review-button',
            text: 'send-for-gtm-review-button',
            backgroundColor: CustomButtonColor.activeBookings,
            handleOnClickCb: gtmReviewButton.onClick,
            disabled: gtmReviewButton.disabled,
          },
        ]
      : []),
    {
      id: 'submit-button',
      text: 'submit-button',
      backgroundColor: CustomButtonColor.submit,
      handleOnClickCb: handleSubmitClick,
    },
  ],
});
